const Modal = {
  parts: ['overlay', 'dialog', 'header', 'body'],
  baseStyle: {
    overlay: {
      bg: 'primaryAlpha',
    },
    header: {
      color: 'mode.900',
    },
    body: {
      color: 'mode.900',
    },
    dialog: {
      color: 'mode.900',
    },
  },
  sizes: {},
  defaultProps: {},
};

export default Modal;
